<template>
  <div class="gd-login">
    <main>
      <h1 class="gd-login__title">eDocGroup</h1>
      <h2 class="gd-login__subtitle">GUI Drivers</h2>
      <div class="gd-login__panel">
        <img src="/static/avatar.svg" alt="" class="gd-login__avatar">
        <i class="loader gd-login__loading" v-if="loadingLogin"></i>
        <form  v-on:submit.prevent="doLogin()" v-else>
          <div class="gd-login__input-part">
            <label for="deskrhLogin" class="gd-login__label">Login :</label>
            <input
              id="deskrhLogin"
              type="text"
              class="gd-input-text gd-login__input"
              required
              v-model="auth.login"
              autocomplete="username">
          </div>
          <div class="gd-login__input-part">
            <label for="deskrhPwd" class="gd-login__label">Mot de passe :</label>
            <input
              id="deskrhPwd"
              type="password"
              class="gd-input-text gd-login__input"
              required
              v-model="auth.password"
              autocomplete="password">
          </div>
          <input
            type="submit"
            class="gd-default-btn gd-btn-default--inverse gd-login__btn"
            value="Se connecter">
        </form>
        <div class="gd-pull-right-layout">
          <div class="gd-pull-right-layout__first-elmt"></div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {

  data() {
    return {
      auth: {
        login: '',
        password: '',
      },
      loadingLogin: false,
    };
  },

  /* watch: {
    authenticated() {
      if (!this.authenticated) {
        this.$store.dispatch('application/openSnackbar', {
          message: `${this.$i18n.t('auth.failed')}`,
        });
      }
    },
  }, */

  computed: {
    ...mapGetters({
      authenticated: 'drivers/authorized',
    }),
  },

  methods: {
    ...mapActions({
      apiLogin: 'drivers/login',
    }),

    doLogin() {
      this.loadingLogin = true;
      this.apiLogin(this.auth)
        .then(() => {
          this.loadingLogin = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Login.vue